import { createElement } from "react";
import { Translation } from "react-i18next";

import { setLibraryNotification, showSnackbar } from "@/app/actions.mjs";
import { GAME_SHORT_NAMES } from "@/app/constants.mjs";
import type { GameOverlay } from "@/hub-overlays/constants.mjs";
import { GAME_OVERLAYS } from "@/hub-overlays/constants.mjs";
import SettingsIcon from "@/inline-assets/settings-button.svg";
import { isOverlayEnabled, setOverlayEnabled } from "@/library/actions.mjs";
import { devError } from "@/util/dev.mjs";
import globals from "@/util/global-whitelist.mjs";

export const pushSnackbarWithSetup = (item: GameOverlay) => {
  showSnackbar({
    id: item.id,
    Text: () =>
      // @ts-ignore
      createElement(Translation, null, (t: TFunction) =>
        t(
          "common:library.overlayAddedToLibrary",
          "{{overlay}} added to Library",
          {
            overlay: t(item.title),
          },
        ),
      ),
    dismissable: false,
    actions: [
      {
        text: ["common:setup", "Setup"],
        iconLeft: createElement(SettingsIcon),
        emphasis: "medium",
        bgColor: "var(--turq-15)",
        bgColorHover: "var(--turq-25)",
        textColor: "var(--turq)",
        textColorHover: "var(--turq)",
        href: `/library/${GAME_SHORT_NAMES[item.game]}?configure=${item.id}`,
      },
      {
        text: ["common:dismiss", "Dismiss"],
        emphasis: "low",
      },
    ],
    dismissOnRouteChange: (route) =>
      route.currentPath.startsWith(`/library/${GAME_SHORT_NAMES[item.game]}`),
  });
};

export function pushSnackbar(item: GameOverlay) {
  showSnackbar({
    id: item.id,
    Text: () =>
      // @ts-ignore
      createElement(Translation, null, (t: TFunction) =>
        t(
          "common:library.overlayAddedToLibrary",
          "{{overlay}} added to Library",
          {
            overlay: t(item.title),
          },
        ),
      ),
    actions: [
      {
        text: ["common:library.goToLibrary", "Go to Library"],
        emphasis: "medium",
        href: "/library",
      },
    ],
    dismissOnRouteChange: (route) => route.currentPath.startsWith("/library"),
  });
}

export const addToLibrary = (item: GameOverlay) => {
  setOverlayEnabled(item, true);
  setLibraryNotification({
    title: item.title,
    description: ["common:library.addedToLibrary", "Added to Library"],
    thumbnail: item.images.small,
  });
  if (item.features) {
    pushSnackbarWithSetup(item);
  } else {
    pushSnackbar(item);
  }
};

export const removeFromLibrary = (item) => {
  setOverlayEnabled(item, false);
};

export const getOverlayPath = (overlay) => {
  try {
    const url = new URL(globals.location?.href);
    url.searchParams.set("selected", overlay.id);
    return url.toString();
  } catch (e) {
    devError("Unable to get overlay path", e);
    return null;
  }
};

export const getEnabledNativeOverlays = (game: symbol) =>
  Object.entries(GAME_OVERLAYS[game])
    .filter(([_, overlay]) => overlay.native && isOverlayEnabled(overlay))
    .map(([id]) => id);
